// @noflow
import './styles.css';

import classNames from 'classnames';
import LogsInfo from './info';
import PropTypes from 'prop-types';
import * as React from 'react';

const LogsPropTypes = {
    logs: PropTypes.arrayOf(
        PropTypes.shape({
            end: PropTypes.number,
            endStyle: PropTypes.shape({
                right: PropTypes.string.isRequired
            }),
            durationMessage: PropTypes.string,
            infoStyle: PropTypes.shape({
                right: PropTypes.string,
                width: PropTypes.string
            }),
            inMotion: PropTypes.bool,
            label: PropTypes.string.isRequired,
            logBGStyle: PropTypes.shape({
                right: PropTypes.string.isRequired,
                width: PropTypes.string.isRequired
            }),
            mergeCount: PropTypes.number,
            start: PropTypes.number,
            startStyle: PropTypes.shape({
                right: PropTypes.string.isRequired
            }),
            timeToDisplay: PropTypes.object
        })
    ).isRequired,
    simpleMergedLabel: PropTypes.bool,
    timelineStyle: PropTypes.object.isRequired
};

const Logs = ({ logs, simpleMergedLabel, timelineStyle }) => (
    <div className="logs-timeline-component__events">
        <div className="logs-timeline-component__events-timeline" style={timelineStyle} />
        {logs.map((log, i) => {
            const {
                end,
                endStyle,
                durationMessage,
                infoStyle,
                inMotion,
                label,
                logBGStyle,
                mergeCount,
                start,
                startStyle,
                timeToDisplay
            } = log;
            const showMultipleEvents = mergeCount > 0;
            return (
                <div
                    className={classNames('logs-timeline-component__log', {
                        'logs-timeline-component--in-motion': inMotion
                    })}
                    data-qa="logs-timeline-event"
                    key={`log-${i}`}
                >
                    <div
                        className={classNames(
                            'logs-timeline-component__log-bg',
                            {
                                'logs-timeline-component__log-bg--round-start': start
                            },
                            {
                                'logs-timeline-component__log-bg--multiple-events': showMultipleEvents
                            }
                        )}
                        style={logBGStyle}
                    />

                    {start && <div className="logs-timeline-component__log-start" style={startStyle} />}
                    {(end || inMotion) && <div className="logs-timeline-component__log-end" style={endStyle} />}
                    {start && (
                        <LogsInfo
                            durationMessage={durationMessage}
                            inMotion={inMotion}
                            label={label}
                            showMultipleEvents={showMultipleEvents}
                            simpleMergedLabel={simpleMergedLabel}
                            style={infoStyle}
                            timeToDisplay={timeToDisplay}
                        />
                    )}
                </div>
            );
        })}
    </div>
);

Logs.propTypes = LogsPropTypes;
export default Logs;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/logs/component.js